import React, {useEffect} from 'react';
import {useSnapshot} from "valtio";
import {
  configuratorState,
  setMaterialLoadingState,
  setSelectedMaterial
} from "../../state";

// sets init specs and default mat
const Initialiser = () => {
  
  const {materialMenusRef, mainMaterialSets} = useSnapshot(configuratorState);
  
  const matSpec = {};
  const partsList = [];
  const matList = [];
  const currMaterialSetsTitles = [];
  
  useEffect(() => {
    
    materialMenusRef.forEach((item) => {
      
      const matRef = item.menu.find(set => set.default);
      
      partsList.push(item.title);
      matList.push(mainMaterialSets[matRef.title][0]);
      currMaterialSetsTitles.push(matRef.title);
      
    });
    //
    let count = matList.length;
    let spec = -1;
    
    matList.forEach(() => {
      
      count -= 1;
      spec += 1;
      setMaterial(count, spec);
      setMaterialLoadingState('loading');
      
    })
    
    configuratorState.currentModelMaterialSpecifications = matSpec;
    
  }, []);
  
  const setMaterial = (index, spec) => {

    setSelectedMaterial(matList[index].title);
    setMaterialSpec(partsList[spec], currMaterialSetsTitles[spec], matList[spec]);
    
  }
  
  const setMaterialSpec = (part, sets, mat) => {
    matSpec[part] = [sets, mat.title];
  }
  
};

export default Initialiser;
